import {
  SectionElement,
  defineElement,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/common-footer/common-footer.ts
var CommonFooter = class extends SectionElement {
  onItemClick(elm) {
    var _a;
    this.inputCountryCode.value = (_a = elm.dataset.value) != null ? _a : "";
    if (this.form) {
      try {
        this.form.submit();
      } catch (e) {
        console.error(e);
      }
    } else {
      console.log("failed to submit country form");
    }
  }
  handleOpenButtonClick(elm) {
    const index = parseInt(elm.dataset.openButton);
    if (this.accordions[index].isOpen) {
      this.close(index);
    } else {
      this.closeAll();
      this.open(index);
    }
  }
  waitForElm(selector, node) {
    const root = node || document.body;
    return new Promise((resolve) => {
      if (root.querySelector(selector)) {
        return resolve(root.querySelector(selector));
      }
      const observer = new MutationObserver((mutations) => {
        if (root.querySelector(selector)) {
          observer.disconnect();
          resolve(root.querySelector(selector));
        }
      });
      observer.observe(root, {
        childList: true,
        subtree: true
      });
    });
  }
  connectedCallback() {
    return __async(this, null, function* () {
      const usercentricsElement = yield this.waitForElm("#usercentrics-root");
      this.cookieButton = yield this.waitForElm("[data-testid]", usercentricsElement.shadowRoot.firstElementChild);
      this.cookieButton.style.display = "none";
    });
  }
  openCookies() {
    var _a;
    if (!this.cookieButton)
      return;
    (_a = this.cookieButton) == null ? void 0 : _a.click();
  }
  open(index) {
    this.accordions[index].open();
    this.chevrons[index].classList.add("rotate-180");
  }
  close(index) {
    this.accordions[index].close();
    this.chevrons[index].classList.remove("rotate-180");
  }
  closeAll() {
    this.accordions.forEach((accordion, index) => this.close(index));
  }
};
__decorateClass([
  query("[data-input-country-code]")
], CommonFooter.prototype, "inputCountryCode", 2);
__decorateClass([
  query("[data-country-button]")
], CommonFooter.prototype, "buttons", 2);
__decorateClass([
  query("form")
], CommonFooter.prototype, "form", 2);
__decorateClass([
  onClick("[data-country-button]")
], CommonFooter.prototype, "onItemClick", 1);
__decorateClass([
  queryAll("[data-accordion]")
], CommonFooter.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-chevron]")
], CommonFooter.prototype, "chevrons", 2);
__decorateClass([
  onClick("[data-open-button]")
], CommonFooter.prototype, "handleOpenButtonClick", 1);
__decorateClass([
  onClick("[data-open-cookies]")
], CommonFooter.prototype, "openCookies", 1);
CommonFooter = __decorateClass([
  defineElement()
], CommonFooter);
export {
  CommonFooter
};
